import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import MultiplesTable from './MultiplesTable';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 30
  },
  conclusions: {
    '& h3': {
      fontSize: 14,
      fontWeight: 'bold'
    },
    '& h6': {
      fontSize: 14,
      fontWeight: 'lighter'
    }
  },
  multiples: {
    '& h3': {
      fontSize: 14,
      fontWeight: 'lighter'
    },
    '& h6': {
      fontSize: 14,
      fontWeight: 'lighter'
    }
  },
  rows: {
    marginTop: 20,
    width: 345
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '10px 0',
    padding: 5
  },
  total: {
    backgroundColor: 'rgba(151,151,151,0.2)',
    borderTop: '1px solid rgba(151,151,151,0.3) ',
    borderBottom: '1px solid rgba(151,151,151,0.3) ',
    margin: '10px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 5,
    '& h6': {
      fontWeight: 'bold'
    }
  },
  totalMultiples: {
    backgroundColor: 'rgba(151,151,151,0.2)',
    margin: '10px 0',
    padding: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& h6': {
      fontWeight: 'bold'
    }
  }
}));

const OutputCash = ({ dataSet }) => {
  const classes = useStyles();

  const renderRow = (name, value) => {
    return (
      <div className={classes.row}>
        <h6>{name}</h6>
        <h6>{value}</h6>
      </div>
    );
  };

  return (
    <div className={classes.container}>
      <div className={classes.conclusions}>
        <h3>DCF conclusions</h3>
        <h6>All figures in EURm (except otherwise stated)</h6>
        <div className={classes.rows}>
          {renderRow(
            'NPV of cashflows (2020 - 2028)',
            dataSet === 'dataA' ? '-794,6' : '-318,5'
          )}
          {renderRow(
            'Terminal value (2028)',
            dataSet === 'dataA' ? '1644,2' : '1644,2'
          )}
        </div>
        <div className={classes.total}>
          <h6>PV of cashflows + terminal value</h6>
          <h6>{dataSet === 'dataA' ? '849,6' : '1325,7'}</h6>
        </div>

        {renderRow('Net financial debt [2019](-)', '(50,0)')}
        {renderRow('EV adjustments [2019](-)', '(50,0)')}

        <div className={classes.total}>
          <h6>Equity Value</h6>
          <h6>{dataSet === 'dataA' ? '949,6' : '1425,7'}</h6>
        </div>
      </div>
      <div className={classes.multiples}>
        <h3>Multiples implied by DCF valuation</h3>
        <h6>
          All data have been calendarized; Using rolling Net Financial Debt
        </h6>
        <MultiplesTable />
      </div>
    </div>
  );
};

export const mapStateToProps = (state) => ({
  dataSet: state.AuthReducer.dataSet
});

export default connect(mapStateToProps, null)(OutputCash);
